import {parserMainClass} from "./mainParser";
import {Injectable} from "@angular/core";
import {gpxParserClass} from "./gpxParser";
import {imageParseClass} from "./imageParser";

@Injectable({
  providedIn: 'root'
})

export class parserFactory{
  public createParserByType(file:File): parserMainClass{
    let fileName = file.name;
    let typeLength = fileName.length - (fileName.lastIndexOf('.')+1);
    let fileType = fileName.substr(-1*(typeLength));

    console.log('fileType', fileType);

    switch (fileType) {
      case 'gpx':
        return new gpxParserClass(file);
      case 'jpg':
      case 'png':
      case 'jpeg':
        return new imageParseClass(file);
      default:
        alert('Wrong file format!');
        break;
    }
    // let type = fileName.substr

    return null;
  }
}
